import type { Level, LevelAttributes } from "building-types/levels/levelTypes";
import type { WindowPlacementDeprecated, WindowPlacementNoExpr } from "building-types/openings/opening";
import { WindowVerticalAlignment, WindowVerticalDatum } from "building-types/openings/openingTypesEnum";
import { type WindowDescriptor } from "building-types/windows/windowTypes";
import { assertUnreachable } from "common/utils/assertUnreachable";
import { getWindowHeight } from "../window/windowHeightTools";

export function resolveWindowPlacementHeadHeight(
  opening: WindowPlacementDeprecated | WindowPlacementNoExpr,
  level: Level,
  levelAttributes: LevelAttributes,
  descriptor: WindowDescriptor,
  windowHeadHeight?: number,
) {
  let verticalDatumHeight: number;

  switch (opening.verticalDatum) {
    case WindowVerticalDatum.TO_FLOOR:
      verticalDatumHeight = 0;
      break;
    case WindowVerticalDatum.TO_WALL_PLATE:
      verticalDatumHeight = level.topOfWall;
      break;
    case WindowVerticalDatum.WINDOW_HEAD_HEIGHT:
    default:
      verticalDatumHeight = windowHeadHeight ?? levelAttributes.windowHeadHeight;
  }

  let headHeightAdjusted = verticalDatumHeight;
  const windowHeight = getWindowHeight(descriptor);

  switch (opening.type) {
    case "WINDOW": {
      switch (opening.verticalAlignment) {
        case WindowVerticalAlignment.BOTTOM:
          headHeightAdjusted += windowHeight;
          break;
        default:
          break;
      }
      break;
    }
    case "WINDOW_V2": {
      switch (opening.verticalAlignment) {
        case WindowVerticalAlignment.BOTTOM:
          headHeightAdjusted += windowHeight;
          break;
        case WindowVerticalAlignment.CENTER:
          headHeightAdjusted += windowHeight / 2;
          break;
        case WindowVerticalAlignment.TOP:
          break;
      }
      break;
    }
    default:
      assertUnreachable(opening);
  }

  return headHeightAdjusted;
}
